import { useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIME, isSupabaseConfigured } from '@/config';
import { useAuth } from '@/lib/auth/AuthProvider';
import { getMyLevel } from '@/lib/data/provider';

/**
 * The caller's XP + level, derived on-demand from every game they play. Lives
 * under the ['rewards', ...] query family so check-in / achievement
 * invalidations refresh it for free.
 */
export function useMyLevel() {
  const { userId } = useAuth();
  return useQuery({
    queryKey: ['rewards', 'level', userId ?? 'anon'],
    queryFn: getMyLevel,
    staleTime: QUERY_STALE_TIME.user,
    enabled: isSupabaseConfigured && Boolean(userId),
  });
}
